export const PATH = {
  LOGIN: "/login",
  REGISTER: "/register",
  CHOOSE_REGISTER: "/choose-register",
  CHAT: "/chat",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",
};

export const AUTH_KEY = "auth";

/** localStorage key for parent URL to return to after LINE login (when in iframe) */
export const PARENT_ORIGIN_KEY = "PARENT_ORIGIN";

/** localStorage key for LINE OAuth CSRF state (mobile redirect flow) */
export const LINE_STATE_KEY = "LINE_OAUTH_STATE";

export const SOURCE_PARENT = "pitaliy-parent-site";
export const SOURCE_IFRAME = "pitaliy-iframe";

export enum AGENT_VERSION {
  Studio = "studio",
  NonStudio = "non_studio",
}

export enum MESSAGE_TYPE {
  HANDSHAKE_REQUEST = "HANDSHAKE_REQUEST",
  HANDSHAKE_RESPONSE = "HANDSHAKE_RESPONSE",
  SET_URL = "SET_URL",
  AGENT_ID = "AGENT_ID",
  FRAME_VIEW = "FRAME_VIEW",
  PARENT_WIDTH = "PARENT_WIDTH",
  // eslint-disable-next-line @typescript-eslint/no-shadow
  AGENT_VERSION = "AGENT_VERSION",
  /** LINE OAuth callback: parent sends code/state to iframe after redirect from LINE */
  LINE_OAUTH_CALLBACK = "LINE_OAUTH_CALLBACK",
}

export const FAQ_LIMIT = 20;

// Default fallback character GIF URL
export const DEFAULT_CHARACTER_GIF_URL =
  "https://recotests.blob.core.windows.net/test/197372ab-6b70-49c6-8867-61c05a52c5d9_ffedf397-be11-4bfe-80f8-f4c12bdb9d55.gif";

export const DEFAULT_VALUE = "default";
export const DEFAULT_FONT_FAMILY = '"Noto Sans JP", sans-serif';
